import { translate } from '@util/Localization';
import { isDirectToPayRoute } from '@util/RouterUtils';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { chooseAddonPlanPerExperiment } from '../../../businessLogic/AddonPlans';
import { useAppStore } from '../../../store/Store';
import { PurchaseSelector } from '../../../store/purchase/PurchaseActions';
import { LightContainer } from '../../styles/ColoredContainers';
import { Heading4 } from '../../styles/Typography';
import { ProductAddon } from '../ProductAddon';
import { MoneyBackGuarantee } from './MoneyBackGuarantee';
import { PlanSummaryTableForm } from './PlanSummaryTableForm';
import { ProductDetails } from './ProductDetails';

export const CheckoutInfo: FunctionComponent = () => {
  const experimentVariant = chooseAddonPlanPerExperiment();
  return (
    <>
      <ProductInfoContainer>
        <PaymentTitle />
        <ProductDetails />
      </ProductInfoContainer>
      <PricingInfoContainer>
        {/* The CountdownTimer is in the place of the MoneyBackGuarantee when visible, so we need to show it
			here instead. Note only visible when not on the /start route. */}
        {!isDirectToPayRoute() && <MoneyBackGuarantee />}
        {experimentVariant !== undefined && <ProductAddon product={experimentVariant} />}
        <PlanSummaryTableForm />
      </PricingInfoContainer>
    </>
  );
};
const PaymentTitle: FunctionComponent = () => {
  const purchase = useAppStore((state) => state.purchase);

  let translateKey = 'payment.startPaidTrial';
  if (!PurchaseSelector.hasTrial(purchase)) {
    translateKey = 'payment.startNoTrial';
  } else if (PurchaseSelector.hasFreeTrial(purchase)) {
    translateKey = 'payment.startFreeTrial';
  }
  const title = translate(translateKey, {
    trialPeriod: purchase.trialPeriodDays,
  });

  return <PaymentHeading>{title}</PaymentHeading>;
};

const PaymentHeading = styled(Heading4)`
  margin-bottom: 12px;
`;

const ProductInfoContainer = styled(LightContainer)`
  border-radius: 30px 30px 30px 30px;
  margin-top: 0px;
  padding: 2em 3em 1em;
  text-align: left;
  img {
    text-align: center;
  }
  margin-bottom: 0px;
`;

export const PricingInfoContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing._8px} ${theme.spacing._16px} ${theme.spacing._16px}
	${theme.spacing._16px}`};
`;
